import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'tr',
  months: [
    'Ocak',
    'Şubat',
    'Mart',
    'Nisan',
    'Mayıs',
    'Haziran',
    'Temmuz',
    'Ağustos',
    'Eylül',
    'Ekim',
    'Kasım',
    'Aralık',
  ],
  monthsShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  weekdays: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
  weekdaysMin: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
  weekdaysShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'D MMMM YYYY dddd HH:mm',
    'LLLL-Y': 'D MMMM dddd HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'D MMM YYYY ddd h:mm A',
    'llll-Y': 'D MMM ddd h:mm A',
    'll-Y+w': 'D MMMM ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'öö', pm: 'ös', AM: 'ÖÖ', PM: 'ÖS' },
  past: {
    y: { one: '%s yıl önce', other: '%s yıl önce' },
    M: { one: '%s ay önce', other: '%s ay önce' },
    w: { one: '%s hf. önce', other: '%s hf. önce' },
    d: { one: '%s gün önce', other: '%s gün önce' },
    h: { one: '%s sa. önce', other: '%s sa. önce' },
    m: { one: '%s dk. önce', other: '%s dk. önce' },
    s: { one: '%s sn. önce', other: '%s sn. önce' },
  },
  future: {
    y: { one: '%s yıl sonra', other: '%s yıl sonra' },
    M: { one: '%s ay sonra', other: '%s ay sonra' },
    w: { one: '%s hf. sonra', other: '%s hf. sonra' },
    d: { one: '%s gün sonra', other: '%s gün sonra' },
    h: { one: '%s sa. sonra', other: '%s sa. sonra' },
    m: { one: '%s dk. sonra', other: '%s dk. sonra' },
    s: { one: '%s sn. sonra', other: '%s sn. sonra' },
  },
  abbr: {
    y: { one: '%syıl', other: '%syıl' },
    M: { one: '%sa', other: '%sa' },
    w: { one: '%sh', other: '%sh' },
    d: { one: '%sg', other: '%sg' },
    h: { one: '%ss', other: '%ss' },
    m: { one: '%sdk', other: '%sdk' },
    s: { one: '%ssn', other: '%ssn' },
  },
  justNow: 'Tam şimdi',
  yesterday: 'Dün',
  today: 'Bugün',
  tomorrow: 'Yarın',
  weekStart: 1,
};
const localeName: LocaleName = 'tr';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'öö' : 'ÖÖ';
    } else {
      return isLowerCase ? 'ös' : 'ÖS';
    }
  },
};
